import { format, parseISO } from 'date-fns';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import localStorage from 'store';
import _replace from 'lodash/replace';

const formatTheDate = (string, dateFormat = 'yyyy-MM-dd') =>
  format(parseISO(string), dateFormat);

const getApiErrorMessage = e => _get(e, 'response.data.message');

const getNoun = (number, one, two, five) => {
  number = Math.abs(number);
  number %= 100;

  if (number >= 5 && number <= 20) {
    return five;
  }
  number %= 10;

  if (number === 1) {
    return one;
  }

  if (number >= 2 && number <= 4) {
    return two;
  }

  return five;
};

const getEnv = () => process.env.NODE_ENV;

const getInitials = (firstName = '', lastName = '') =>
  `${firstName},${lastName}`
    .split(',')
    .map(char => char[0])
    .join('');

const getValueStorage = key => localStorage.get(key);

const setValueStorage = (key, value) => localStorage.set(key, value);

const getUserByKey = (key, isAuthenticated) => {
  if (!isAuthenticated) {
    return false;
  }

  return (
    getValueStorage('insurance_item') != null &&
    getValueStorage('insurance_item').type === key
  );
};

const displayDateWithTime = str => {
  const [date, time] = str.split(' ');

  return `${formatTheDate(date, 'dd.MM')}
    ${time.split(':').slice(0, -1).join(':')}`;
};

const getUserType = () => {
  let user = null;
  let token = getValueStorage('token');

  if (!token) {
    user = 'quest';
  } else {
    let type =
      getValueStorage('insurance_item') !== undefined &&
      getValueStorage('insurance_item').type;
    if (type) {
      if (type === 'insurance') {
        user = 'insurance';
      } else if (type === 'sales_agent_company') {
        user = 'sales_agent_company';
      }
    } else {
      user = 'user';
    }
  }

  return user;
};

const getOr = (obj, path, def) => {
  let val = _get(obj, path);

  return _isNil(val) ? def : val;
};

const replaceStr = (str, pattern, replacement = '') =>
  _replace(str, pattern, replacement)
    ? _replace(str, pattern, replacement)
    : str;

const setVhProperty = () =>
  document.documentElement.style.setProperty(
    '--vh',
    `${window.innerHeight * 0.01}px`
  );

const transformToLowercase = (str, capitalize = true) =>
  capitalize ? str.charAt(0) + str.toLowerCase().slice(1) : str.toLowerCase();

const bodyScrollFix = () =>
  document.querySelector('body').removeAttribute('style');

export const camelCasePattern = /(?=[A-Z])/;

export const toKebabCase = (str, pattern = /(?=[A-Z])/, postProcess = false) =>
  postProcess
    ? str
        .split(pattern)
        .map(word => word.toLowerCase())
        .join('-')
    : str.split(pattern).join('-');

const compare = (a, b) => a.id - b.id || a.name.localeCompare(b.name);

export {
  getEnv,
  getInitials,
  getValueStorage,
  setValueStorage,
  getOr,
  getUserType,
  replaceStr,
  setVhProperty,
  displayDateWithTime,
  getUserByKey,
  getNoun,
  getApiErrorMessage,
  formatTheDate,
  transformToLowercase,
  bodyScrollFix,
  compare,
};
